import { Controller } from "@hotwired/stimulus"

// This controller resets a form after successful submission via Turbo Streams
// without losing focus on the input field
export default class extends Controller {
  connect() {
    this.element.addEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.handleSubmitEnd)
  }

  handleSubmitEnd(event) {
    if (event.detail.success) {
      // Find the first textarea or input in the form
      const inputField = this.element.querySelector("textarea, input[type='text']")
      
      // Store focus and cursor position
      const hasFocus = document.activeElement === inputField
      const cursorPosition = hasFocus ? inputField.selectionStart : 0
      
      // Reset the form
      this.element.reset()
      
      // If input had focus before, restore it
      if (hasFocus && inputField) {
        // Use setTimeout to allow the browser to complete other tasks
        setTimeout(() => {
          inputField.focus()
          if (inputField.setSelectionRange) {
            inputField.setSelectionRange(0, 0)
          }
        }, 0)
      }
    }
  }
}